import { ToolbarPopoverButton } from "@-/dev.improve.haniverse.components.ui.toolbar.button.popover";
import type { ReactNode } from "react";

/**
 * Levels filter popover shell. The only filter offered today is the hide-completed toggle (passed
 * as `children`); card filters (HSK/TBCL, tier/usage, stage) are not shown — levels are already
 * scoped by the curriculum material tabs. Options apply immediately; there is no Done button.
 */
export function LevelsFilterMenu({
  children,
  selected = false,
}: {
  children?: ReactNode;
  /** Accent the Filters pill when a non-default filter is active. */
  selected?: boolean;
}) {
  return (
    <ToolbarPopoverButton
      accessibilityLabel="Filter levels"
      label="Filters"
      name="MdTune"
      selected={selected}
    >
      {children}
    </ToolbarPopoverButton>
  );
}
